import Cookies from 'js-cookie';
import {
  CommonService,
  UserOptionName,
} from '~/settings/service/CommonService';
import StampService from '~/settings/service/StampService';

const langMap = {
  zh_CN: { zh_CN: 0, zh_TW: 4, ko_KR: 1, en_US: 2, ja_JP: 3 },
  zh_TW: { zh_CN: 4, zh_TW: 0, ko_KR: 1, en_US: 2, ja_JP: 3 },
  ko_KR: { zh_CN: 3, zh_TW: 4, ko_KR: 0, en_US: 1, ja_JP: 2 },
  en_US: { zh_CN: 3, zh_TW: 4, ko_KR: 1, en_US: 0, ja_JP: 2 },
  ja_JP: { zh_CN: 3, zh_TW: 4, ko_KR: 2, en_US: 1, ja_JP: 0 },
};
const lang = Cookies.get('language') ?? Cookies.get('LC') ?? 'en_US';

export const IndexDBStatus = {
  Exist: 1,
  NotExists: 0,
  NotSupport: -1,
};

export class StampBiz {
  static getStampEnable() {
    return CommonService.getOptionValueAsBoolean(
      UserOptionName.STAMPSUGGESION_ENABLE,
    );
  }

  static async getLangOptions() {
    const [error, list] = await StampService.checkSupportLanguage();
    if (error || !Array.isArray(list)) {
      return [];
    }
    const langSequence = langMap[lang];
    const result = new Array(list.length);
    for (let i = 0, len = list.length; i < len; i++) {
      let x = list[i];
      let temp = {
        locale: x.locale,
        id: 'chk_lang_' + x.locale,
        label: x.label,
        enable: StampService.getUserOptionForLanguage(x.locale),
        value: x.locale,
      };
      result[langSequence[x.locale]] = temp;
    }
    return result;
  }

  static async save({ enabled, languageOptions }) {
    CommonService.setOptionValue(
      UserOptionName.STAMPSUGGESION_ENABLE,
      enabled,
      false,
    );
    languageOptions.forEach((x) => {
      StampService.setUserOptionForLanguage(x.locale, x.enable);
    });
    const resp = await CommonService.save(true);
    if (!resp.data || (resp.data && resp.data.code !== 200)) {
      return false;
    } else {
      return true;
    }
  }

  static async download() {
    const isSuccess = await StampService.syncData();
    return isSuccess;
  }
}
